
const SERVER = process.env.REACT_APP_SERVER_URL || "http://localhost:9000"
const SERVERWS = process.env.REACT_APP_SERVER_URL_WS || "ws://localhost:9000"
export const AD_CLIENT_ID = "06572a3f-f284-4a21-8b9e-fed62288abe1"
export const AD_TENANT_ID = "07597248-ea38-451b-8abe-a638eddbac81"
export const AD_REDIRECT_URI = process.env.AD_REDIRECT_URI || "https://lacountydiversion.org/loginAD"

//********************************************************************************************
//DO NOT CHANGE ANYTHING BELOW THIS LINE ON YOUR DEV BOX UNLESS YOU ARE 100% SURE WHAT YOU ARE DOING.
//********************************************************************************************
export const server = {
  http: `${SERVER}/ql`,
  ws: `${SERVERWS}/ws`,
}
//********************************************************************************************

export const TIMEOUT_PERIODS = {
  MODALTIMEOUT: 30,  // 5 minutes (300 seconds) This is the time the modal will stay open before the user is logged out
  SESSION: 14* 60 * 1000,      // 14 minutes (840 seconds) This is the time the user will be logged out if they are inactive
  ACTIVITYTIME: 10 * 60 * 1000  // 10 minutes (600 seconds) If the user has been active in the past X minutes, auto refresh the token 
};

 